import Vue from 'vue'

const initialise = (state) => {
    let json = localStorage.getItem('store')
    if (json) {
        Object.assign(state, JSON.parse(json))
    }
}

const clearClaimsList = (state) => {
    state.claimsList = []
}

const setLoading = (state, payload) => {
    state.loading = payload
}

const setClaimsList = (state, payload) => {
    state.claimsList = payload
}

const setFormUserList = (state, payload) => {
    state.formUserList = payload
}

const setTaskHistoryList = (state, payload) => {
    state.taskHistoryList = payload
}

const setSelectedClaim = (state, payload) => {
    state.selectedClaim = payload
}

const setSelectedClaimIndex = (state, payload) => {
    state.selectedClaimIndex = payload
}

const setPagenation = (state, payload) => {
    state.pagenation = payload
}

const setPageNumber = (state, payload) => {
    if (state.pagenation === null) {
        state.pagenation = { pageNumber: payload }
    } else {
        state.pagenation.pageNumber = payload
    }
}

const setPageSize = (state, payload) => {
    if (state.pagenation === null) {
        state.pagenation = { pageSize: payload }
    } else {
        state.pagenation.pageSize = payload
    }
}

const setDocumentTypes = (state, payload) => {
    state.documentTypes = payload
}

const setDeclinationReasons = (state, payload) => {
    state.declinationReasons = payload
}

const setManualStatuses = (state, payload) => {
    state.manualStatuses = payload
}

const setResellers = (state, payload) => {
    state.resellers = payload
}

const setUnderwriters = (state, payload) => {
    state.underwriters = payload
}

const setTaskTypes = (state, payload) => {
    state.taskTypes = payload
}

const setTaskTypesOutstanding = (state, payload) => {
    state.taskTypesOutstanding = payload
}

const setIncidentTypes = (state, payload) => {
    state.incidentTypes = payload
}

const setRepairProviders = (state, payload) => {
    state.repairProviders = payload
}

const setRepairOptionWebDisplay = (state, payload) => {
    state.repairOptionWebDisplay = payload
}

const setRepairOptionTypes = (state, payload) => {
    state.repairOptionTypes = payload
}

const setEmailTemplates = (state, payload) => {
    state.emailTemplates = payload
}

const setManDeviceRepairPreConfigItems = (state, payload) => {
    state.manDeviceRepairPreConfigItems = payload
}

const setEmailPreview = (state, payload) => {
    state.emailPreview = payload
}

const addDeveloperException = (state, payload) => {
    state.developerExceptions.push(payload)
}

const setPipelines = (state, payload) => {
    state.pipelines = payload
}

const setPipelineTypes = (state, payload) => {
    state.pipelineTypes = payload
}

const setResellerPipelines = (state, payload) => {
    state.resellerPipelines = payload
}

const setSelectedResellerPipeline = (state, payload) => {
    state.selectedResellerPipeline = payload
}

const setSelectedPipeline = (state, payload) => {
    state.selectedPipeline = payload
}

const setPipelineRules = (state, payload) => {
    state.pipelineRules = payload
}

const setSelectedRule = (state, payload) => {
    state.selectedPipelineRule = payload
}

const setRuleParameters = (state, payload) => {
    state.ruleParameters = payload
}

const setRuleComponents = (state, payload) => {
    state.ruleComponents = payload
}

const setRepairOptionInstructions = (state, payload) => {
    state.repairOptionInstructions = payload
}

const setSelectedOptionInstructions = (state, payload) => {
    state.selectedOptionInstructions = payload
}

const addClaimNote = (state, payload) => {
    state.selectedClaim.notes = payload
}

const setRepairOptionMatrix = (state, payload) => {
    state.repairOptionMatrix = payload
}

const setDeviceTypes = (state, payload) => {
    state.deviceTypes = payload
}

const setDeviceMakes = (state, payload) => {
    state.deviceMakes = payload
}

const setClaimEmailHistory = (state, payload) => {
    state.selectedClaim.emailHistoryDetails = payload
}

const setClaimStatusHistory = (state, payload) => {
    state.selectedClaim.claimStatusDetails = payload
}

const setClaimPipelineRunHistory = (state, payload) => {
    state.selectedClaim.pipelineRunHistoryDetails = payload
}

const setClaimSelectedRepairOptions = (state, payload) => {
    state.selectedClaim.selectedRepairOptionDetails = payload
}

const setClaimExcessPayments = (state, payload) => {
    state.selectedClaim.excessPaymentDetails = payload
}

const setClaimDocuments = (state, payload) => {
    state.selectedClaim.documentDetails = payload
}

const setClaimExcessCalculations = (state, payload) => {
    state.selectedClaim.excessCalculations = payload
}

const setClaimPolicy = ({ selectedClaim }, payload) => {
    const propName = 'policyDetails'
    if (selectedClaim) {
        if (selectedClaim.hasOwnProperty(propName)) {
            selectedClaim[propName] = payload
        } else {
            Vue.set(selectedClaim, propName, payload)
        }
    }
}

const setClaimUser = ({ selectedClaim }, payload) => {
    const propName = 'userDetails'
    if (selectedClaim) {
        if (selectedClaim.hasOwnProperty(propName)) {
            selectedClaim[propName] = payload
        } else {
            Vue.set(selectedClaim, propName, payload)
        }
    }
}

const setClaimUserLoginHistory = ({ selectedClaim }, payload) => {
    const propName = 'userLoginHistory'
    if (selectedClaim) {
        if (selectedClaim.hasOwnProperty(propName)) {
            selectedClaim[propName] = payload
        } else {
            Vue.set(selectedClaim, propName, payload)
        }
    }
}

const setSalesDocumentUploads = (state, payload) => {
    state.salesDocumentUploads = payload
}

const selectedClaimAddReplaceGadget = (state, payload) => {
    if (payload) {
        if (state.selectedClaim) {
            if (state.selectedClaim.gadgetDetails && Array.isArray(state.selectedClaim.gadgetDetails)) {
                let idx = state.selectedClaim.gadgetDetails.findIndex(g => g.id == payload.id)
                if (idx != -1) {
                    state.selectedClaim.gadgetDetails.splice(idx, 1, payload);
                } else {
                    state.selectedClaim.gadgetDetails.push(payload)
                }
            }
        }
    }
}

const setClaimGadgetOptionsPreview = (state, payload) => {
    state.gadgetOptionsPreview = payload
}

const setClaimSelectedGadgetDetails = (state, payload) => {
    state.selectedClaim.gadgetDetails = payload
}

const setClaimSelectedTaskHistory = (state, payload) => {
    state.selectedClaim.taskHistoryDetails = payload
}

const setClaimDocumentsLoading = (state, payload) => {
    state.claimDocumentsLoading = payload
}

const setClaimUserIdEmail = ({ selectedClaim }, payload) => {
    try {
        const propNames = ['userId', 'webUserEmail']
        if (selectedClaim && payload) {
            for (let i = 0; i < propNames.length; i++) {
                if (payload.hasOwnProperty(propNames[i])) {
                    if (selectedClaim.hasOwnProperty(propNames[i])) {
                        selectedClaim[propNames[i]] = payload[propNames[i]]
                    } else {
                        Vue.set(selectedClaim, propNames[i], payload[propNames[i]])
                    }
                }
            }
        }
    } catch (err) { console.log('-err: ', err) }
}

const setIncidentDate = (state, payload) => {
    state.selectedClaim.incidentDate = payload;
}

export default {
    initialise,
    clearClaimsList,
    setLoading,
    setClaimsList,
    setFormUserList,
    setTaskHistoryList,
    setSelectedClaim,
    setSelectedClaimIndex,
    setPagenation,
    setPageNumber,
    setPageSize,
    setDocumentTypes,
    setDeclinationReasons,
    setManualStatuses,
    setResellers,
    setTaskTypes,
    setTaskTypesOutstanding,
    setIncidentTypes,
    setRepairProviders,
    setRepairOptionWebDisplay,
    setRepairOptionTypes,
    setEmailTemplates,
    setManDeviceRepairPreConfigItems,
    setEmailPreview,
    addDeveloperException,
    setPipelines,
    setPipelineTypes,
    setResellerPipelines,
    setSelectedResellerPipeline,
    setSelectedPipeline,
    setPipelineRules,
    setSelectedRule,
    setRuleParameters,
    setRuleComponents,
    setRepairOptionInstructions,
    setSelectedOptionInstructions,
    addClaimNote,
    setRepairOptionMatrix,
    setDeviceTypes,
    setDeviceMakes,
    setClaimEmailHistory,
    setClaimStatusHistory,
    setClaimPipelineRunHistory,
    setClaimSelectedRepairOptions,
    setClaimExcessPayments,
    setClaimDocuments,
    setClaimExcessCalculations,
    setClaimPolicy,
    setClaimUser,
    setClaimUserLoginHistory,
    setSalesDocumentUploads,
    selectedClaimAddReplaceGadget,
    setClaimGadgetOptionsPreview,
    setUnderwriters,
    setClaimSelectedGadgetDetails,
    setClaimSelectedTaskHistory,
    setClaimDocumentsLoading,
    setClaimUserIdEmail,
    setIncidentDate
}
